import React, { FC, useEffect } from 'react'

import Title from 'antd/lib/typography/Title'
import { useNavigate } from 'react-router-dom'

interface IProps {
  to: string
}

const RedirectTo: FC<IProps> = ({ to }: IProps) => {
  const navigate = useNavigate()

  useEffect(() => {
    navigate(to)
  }, [navigate, to])

  return <Title>Redirecionando</Title>
}

export default RedirectTo
